/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

const moment = require('moment');
const { default: __vue_component__ } = require('vue-pincode-input');

//require('./bootstrap');

window.Vue = require('vue');

// set default dropzone messages
Dropzone.prototype.defaultOptions.dictDefaultMessage = "Drop file here to upload or click to browse computer.";
Dropzone.prototype.defaultOptions.dictMaxFilesExceeded = "Multiple file selection is not supported.";
Dropzone.prototype.defaultOptions.dictInvalidFileType = "Uploading files of this type is not supported. Please convert the file to a PDF before uploading.";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

 // these names should be two words to avoid potential conflicts with html elements
Vue.component('claim-list', require('./components/claims/ClaimListComponent.vue').default);
Vue.component('claim-detail', require('./components/claims/ClaimDetailComponent.vue').default);
Vue.component('claim-documents', require('./components/claims/ClaimDocumentsComponent.vue').default);
Vue.component('claim-notes', require('./components/claims/ClaimNotesComponent.vue').default);
Vue.component('archived-claim-list', require('./components/claims/ArchivedClaimListComponent.vue').default);

Vue.component('admin-claim-list', require('./components/admin/AdminClaimListComponent.vue').default);
Vue.component('admin-archived-claim-list', require('./components/admin/AdminArchivedClaimListComponent.vue').default);

Vue.component('file-upload-modal', require('./components/FileUploadComponent.vue').default);
Vue.component('npi-search-modal', require('./components/NPISearchComponent.vue').default);
Vue.component('payer-identification-code', require('./components/admin/PayerIdentificationCodeComponent.vue').default);
Vue.component('signature', require('./components/admin/SignatureComponent.vue').default);

Vue.component('payer-list', require('./components/payers/PayerListComponent.vue').default);
Vue.component('payer-contract-list', require('./components/payers/PayerContractListComponent.vue').default);

Vue.component('contact-list', require('./components/contacts/ContactList.vue').default);

Vue.component('inbox-menu-item', require('./components/inbox/InboxMenuItemComponent.vue').default);
Vue.component('inbox-list', require('./components/inbox/InboxListComponent.vue').default);

Vue.component('chart-preferences-modal', require('./components/charts/ChartPreferencesComponent.vue').default);
Vue.component('overdue-documents-chart', require('./components/charts/OverdueDocumentsChartComponent.vue').default);
Vue.component('disputable-authorizations-chart', require('./components/charts/DisputableAuthorizationsChartComponent.vue').default);
Vue.component('line-chart', require('./components/charts/LineChartComponent.vue').default);
Vue.component('bar-chart', require('./components/charts/BarChartComponent.vue').default);
Vue.component('pie-chart', require('./components/charts/PieChartComponent.vue').default);
Vue.component('unread-documents-list', require('./components/charts/UnreadDocumentsComponent.vue').default);
Vue.component('recently-shared-claims-chart', require('./components/charts/RecentlySharedClaimsChartComponent.vue').default);
Vue.component('overdue-claim-payments-chart', require('./components/charts/OverdueClaimPaymentsChartComponent.vue').default);
Vue.component('unsubmitted-documents-chart', require('./components/charts/UnsubmittedDocumentsComponent.vue').default);
Vue.component('edi-file-uploads-chart', require('./components/charts/EdiFileUploadsComponent.vue').default);
Vue.component('failed-edi-file-uploads-chart', require('./components/charts/FailedEdiFileUploadsComponent.vue').default);

Vue.component('overdue-documents-report', require('./components/reports/OverdueDocumentsReport.vue').default);
Vue.component('disputable-authorizations-report', require('./components/reports/DisputableAuthorizationsReport.vue').default);
Vue.component('recently-shared-claims-report', require('./components/reports/RecentlySharedClaimsReport.vue').default);
Vue.component('overdue-claim-payments-report', require('./components/reports/OverdueClaimPaymentsReport.vue').default);
Vue.component('unsubmitted-documents-report', require('./components/reports/UnsubmittedDocumentsReport.vue').default);
Vue.component('edi-file-uploads-report', require('./components/reports/EdiFileUploadsReport.vue').default);
Vue.component('failed-edi-file-uploads-report', require('./components/reports/FailedEdiFileUploadsReport.vue').default);

Vue.component('penalty-summary-chart', require('./components/charts/PenaltySummaryComponent.vue').default);
Vue.component('service-list', require('./components/services/ServiceListComponent.vue').default);

Vue.component('inactivity-message', require('./components/InactivityMessageComponent.vue').default);

Vue.component('notifications-list', require('./components/admin/NotificationsListComponent.vue').default);
Vue.component('notification-users-modal', require('./components/admin/NotificationUsersModal').default);

Vue.component('delete-confirmation', require('./components/DeleteConfirmationComponent.vue').default);
Vue.component('confirmation-modal', require('./components/ConfirmationComponent.vue').default);

Vue.component('facility-list', require('./components/facility/FacilityListComponent.vue').default);
Vue.component('facility-modal', require('./components/facility/FacilityComponent.vue').default);

Vue.component('user-preferences', require('./components/UserPreferencesComponent.vue').default);

Vue.component('attorney-claim-list', require('./components/attorney/AttorneyClaimListComponent.vue').default);
Vue.component('attorney-claim', require('./components/attorney/AttorneyClaimComponent.vue').default);
Vue.component('attorney-archived-claim-list', require('./components/attorney/AttorneyArchivedClaimListComponent.vue').default);

Vue.component('verification-code-input', require('./components/secure_email/VerificationCodeComponent.vue').default);
Vue.component('download-confirmation', require('./components/secure_email/DownloadConfirmationComponent.vue').default);

Vue.component('transmissions-list', require('./components/transmissions/TransmissionsListComponent.vue').default);

Vue.component('rms-documents', require('./components/rms/RmsDocumentsComponent.vue').default);

Vue.component('export-customer', require('./components/admin/ExportCustomerComponent.vue').default);

Vue.component('output-frame', require('./components/OutputFrameComponent.vue').default);

Vue.component('user-list', require('./components/admin/UserListComponent.vue').default);
Vue.component('user-details', require('./components/admin/UserDetailsComponent.vue').default);

Vue.component('localized-time', require('./components/LocalizedTimeComponent.vue').default);
Vue.component('document-notes', require('./components/documents/DocumentNotesComponent.vue').default);
Vue.component('service-associated-documents', require('./components/services/ServiceAssociatedDocumentsComponent.vue').default);
Vue.component('service-document', require('./components/services/ServiceDocumentComponent.vue').default);

Vue.component('attorney-1008-list', require('./components/attorney/Attorney1008ListComponent.vue').default);

Vue.component('researcher-claim-list', require('./components/researcher/ResearcherClaimListComponent.vue').default);
Vue.component('researcher-claim', require('./components/researcher/ResearcherClaimComponent.vue').default);

Vue.component('historical-upload-modal', require('./components/historical/HistoricalUploadComponent.vue').default);
Vue.component('historical-service-list', require('./components/historical/HistoricalServiceListComponent.vue').default);
Vue.component('historical-service-form', require('./components/historical/HistoricalServiceFormComponent.vue').default);

Vue.component('reimbursement-settings', require('./components/ReimbursementSettingsComponent.vue').default);

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => {
//     return Vue.component(_.last(key.split('/')).split('.')[0], files(key))
// })


Vue.filter('localizeTime', function(value, format) {
    if (!value) return '';

    if (!value.endsWith('Z')) {
        value = value + 'Z';
    }

    return moment(value).format(format);
});

Vue.filter('capitalize', function(value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('currency', function(value) {
    if (!value) return '0.00';
    //if (typeof value !== 'number') return value;
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        currency: 'USD',
        useGrouping: true,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return formatter.format(value);
});

Vue.filter('telephone', function (value) {
    if (!value) return '';
    var numericOnly = value.replace(/[^0-9]/g, '');
    var formattedValue = numericOnly.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3').substring(0, 14);
    return formattedValue;    
});

Vue.filter('truncate', function (value, length) {
    return (value && (value.length > length)) ? value.substring(0, length) + '...' : value;
});

Vue.component('combobox', {
    inheritAttrs: false,
    props: ['value', 'options'],
    data() { return { local: this.value } },
    watch: {
        value(val) {
            this.$emit('input', this.local);
        },
        local(val) {
            this.$emit('input', this.local);
        }
    },
    template: '<div><input id="combobox" type="text" v-bind="$attrs" v-model="value" list="options-list" /><datalist id="options-list"><option v-for="option in options" :key="option">{{ option }}</option></datalist></div>'    
})

Vue.component('currency-input', {
    inheritAttrs: false,
    props: ['value'],
    data() { return { local: this.value } },  
    template: '<input type="number" min="0.00" step="0.01" v-model="local" size="10" />'
});

Vue.component('localized-datetime', {
    inheritAttrs: false,
    props: ['value'],
    data() { return { local: this.value } },
    template: "<span>{{ value | localizeTime('YYYY-MM-DD HH:mm:ss') }}</span>"
});

Vue.component('telephone-input', {
    inheritAttrs: false,
    props: ['value'],
    data() { return { local: this.value }},
    watch: { 
        value(val) {
            this.local = this.format(val);
            this.$emit('input', this.local);             
        },
        local(val) {
            this.local = this.format(val);
            this.$emit('input', this.local); 
        }
    },
    methods: {
        format: function (val) {
            if (val) {
                var numericOnly = val.replace(/[^0-9]/g, '');
                var formattedValue = numericOnly.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3').substring(0, 14);
                return formattedValue;
            }
            return null;
        }
    },
    mounted() {
        this.local = this.format(this.value);
    },
    // template: '<input type="tel" pattern="\(\d{3}\) \d{3}-\d{4}" v-bind="$attrs" v-model="local">',
    template: '<input type="tel" v-bind="$attrs" v-model="local">',
});

Vue.component('ssn-input', {
    inheritAttrs: false,
    props: ['value'],
    data() { return { local: '' }},
    watch: {
        value(val) {
            this.local = this.format(val);
            this.$emit('input', this.local);             
        },        
        local(val) {
            this.local = this.format(val);
            this.$emit('input', this.local);
        }
    },
    methods: {
        format: function (val) {
            if (val) {
                var numericOnly = val.replace(/[^0-9]/g, '');
                var formattedValue = numericOnly.replace(/(\d{3})(\d{2})(\d{4})/g, '$1-$2-$3').substring(0, 11);
                return formattedValue
            }

            return null;
        }
    },
    mounted() {
        this.local = this.format(this.value);      
    },
    template: '<input type="text" pattern="\d{3}-\d{2}-\d{4}" v-bind="$attrs" v-model="local">',
});


window.eventHub = new Vue();

import Vue from 'vue';
import { DocumentType } from './constants.js'; 

const app = new Vue({
    el: '#app',
    data: {
        DocumentType: DocumentType
    },
    methods: {
        onSearch: function (clientId) {
            eventHub.$emit('show-npi-search', clientId);
        },
        confirmDelete: function (objectName, href) {
            if (href) {

                const token = objectName.trim().toLowerCase().replace(' ', '-');
                eventHub.$emit('show-delete-' + token + '-confirmation', href);
            }
        },
        deleteObject: function (href) {
            if (href) {
                window.location.href = href;
            }
        },
        confirm: function (title, message) {
            eventHub.$emit('show-confirmation', title, message, null);
        },
        expanded: function () {
            let retval = false;
            try {

                retval = localStorage.getItem('worx.sidebar.documents.expanded');                
            }
            catch(e) { /* nothing to do */ }

            return retval;
        },
        toggleMenuState: function () {

            try {

                let el = $('#documents-submenu');
                if (el.length) {

                    if (el.hasClass('show')) {
                        localStorage.setItem('worx.sidebar.documents.expanded', true);
                    }
                    else {
                        localStorage.removeItem('worx.sidebar.documents.expanded');
                    }
                }
            }
            catch(e) { /* nothing to do */ }
        },
        showHistoricalUpload: function (client) {
            eventHub.$emit('show-historical-upload', client);
        }              
    },
    created() {

        let el = $('#documents-submenu');
        if (el.length && this.expanded()) {
            el.collapse('show');
        }
    },
    mounted() {

        let self = this;
        let el = $('#documents-submenu');
        if (el.length) {
            el.on('shown.bs.collapse', function () { self.toggleMenuState(); });
            el.on('hidden.bs.collapse', function () { self.toggleMenuState(); });
        }
    }
});
